module.exports = __webpack_public_path__ + "img/banner.612314d7.jpg";